module.exports = __webpack_public_path__ + "static/if-i-could-tell-you-just-one-thing-c863df95c6575b387231a8b68cd16aac.jpg";